import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dropdownItemContainer: {
    "&:hover": {
      backgroundColor: semanticColors.background.actionLight,
      color: semanticColors.foreground.primary,
    },
  },
  dropdownItem: {
    border: "none",
    boxShadow: "none",
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.normal,
    padding: "8px 16px",
    justifyContent: "flex-start",
    width: "100%",
    "& .MuiButton-startIcon": {
      marginRight: "8px",
    },
    "&:disabled": {
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
      color: semanticColors.foreground.disabled,
    },
    "&:hover, &:active": {
      backgroundColor: semanticColors.background.actionLight,
      border: "none",
      boxShadow: "none",
    },
  },
  deleteMenuItem: {
    color: semanticColors.foreground.errorLarge,
  },
  customCssBadge: {
    marginLeft: '8px',
  },
});
